module.exports = __webpack_public_path__ + "assets/ac643babed4178ae48fd54475c623ca3.mp3";